import React from 'react';

type Rule = {
  key: string;
  label: string;
  passed: boolean;
};

type PasswordRequirementsProps = {
  password: string;
  confirm?: string;
  minLength?: number;
  showConfirmMatch?: boolean;
  className?: string;
};

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
  confirm,
  minLength = 8,
  showConfirmMatch = false,
  className = '',
}) => {
  const rules: Rule[] = [
    {
      key: 'length',
      label: `At least ${minLength} characters`,
      passed: password.length >= minLength,
    },
  ];

  if (showConfirmMatch) {
    rules.push({
      key: 'match',
      label: 'Passwords match',
      passed: Boolean(password) && password === (confirm || ''),
    });
  }

  const allPassed = rules.every((rule) => rule.passed);

  return (
    <div className={`rounded-lg border px-3 py-2 text-xs ${className} ${
      allPassed ? 'border-emerald-200 bg-emerald-50/60 text-emerald-700 dark:border-emerald-700/50 dark:bg-emerald-900/20 dark:text-emerald-200'
        : 'border-slate-200 bg-white/70 text-slate-600 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-300'
    }`}>
      <div className="mb-1 font-semibold uppercase tracking-[0.2em] text-[10px]">
        Password requirements
      </div>
      <ul className="space-y-1">
        {rules.map((rule) => (
          <li key={rule.key} className="flex items-center gap-2">
            <span
              className={`inline-flex h-4 w-4 items-center justify-center rounded-full border text-[10px] ${
                rule.passed
                  ? 'border-emerald-400 bg-emerald-500 text-white'
                  : 'border-amber-300 bg-amber-100 text-amber-700 dark:border-amber-500/50 dark:bg-amber-900/30 dark:text-amber-200'
              }`}
              aria-hidden
            >
              {rule.passed ? '✓' : '!'}
            </span>
            <span>{rule.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
